export function byId<T extends { id: string }>(items: T[]): Map<string, T> {
  const map: Map<string, T> = new Map(
    items.map((item): [string, T] => [item.id, item]),
  );

  return map;
}



// WEBPACK FOOTER //
// ./app/gamma/src/util/byId.ts